module.exports = __webpack_public_path__ + "static/media/TV.a03c58a6.png";